import { Pipe, PipeTransform } from '@angular/core';
import { Gender } from '@app/shared/enums/Gender.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'gender',
    standalone: false
})
export class GenderPipe implements PipeTransform {
  public gender = Gender;
  public genderList: any[] = [];

  constructor(public translate: TranslateService) { }

  transform(value: any): string {
    if (!value) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const states = Array.isArray(value) ? value : [value];

    if (states.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedStates = states
      .map(state => {
        const key = Object.keys(Gender).find(
          k => Gender[k as keyof typeof Gender] === state
        );
        return key ? this.translate.instant(`ENUMS.GENDER_${key}`) : null;
      })
      .filter(Boolean);

    return translatedStates.length > 0
      ? translatedStates.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }

  getList() {
    this.genderList = [];

    for (const [propertyKey, propertyValue] of Object.entries(Gender)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }

      this.genderList.push({ id: !!propertyValue, name: this.translate.instant('ENUMS.' + propertyKey) });
    }

    return this.genderList;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(Gender)) {
      if (propertyValue == Id) {
        return { id: propertyValue, name: this.translate.instant('ENUMS.' + propertyKey) };
      }
    }
    return null;
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(Gender)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null;
  }
}
